var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInAppNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web-tab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 12.7087C2.5 13.6292 3.24617 14.3753 4.16667 14.3753H12.5C13.4205 14.3753 14.1667 13.6292 14.1667 12.7087V4.37533C14.1667 3.22666 13.2324 2.29199 12.0833 2.29199H4.58333C3.43467 2.29199 2.5 3.22666 2.5 4.37533V12.7087ZM6.66667 3.12533H12.0833C12.7726 3.12533 13.3333 3.68608 13.3333 4.37533V5.62533H6.66667V3.12533ZM3.33333 4.37533C3.33333 3.68608 3.89408 3.12533 4.58333 3.12533H5.83333V5.62533H3.33333V4.37533ZM15 17.7087H5.83333C4.91283 17.7087 4.16667 16.9625 4.16667 16.042H12.5C14.3384 16.042 15.8333 14.5467 15.8333 12.7087V4.52841C16.8021 4.87283 17.5 5.78841 17.5 6.87533V15.2087C17.5 16.5894 16.3807 17.7087 15 17.7087Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAppNotification);
export default __webpack_public_path__ + "static/media/inAppNotification.b5e89be692224e7661800d4be821efc1.svg";
export { ForwardRef as ReactComponent };